import { observable, action, computed } from "mobx";
import { post, get, deleted } from "../services/ajax.service";

class ReportStore {
  @observable reports = [];
  @observable report_byId = [];
  @observable limit = 10;
  @observable tiles = 0;
  @observable reportError = "";
  @observable action = false;
  @observable errors = {};
  @observable allReports = [];
  @observable reports_count = 0;
  @observable template_report = "";
  @observable template_section = [];
  @observable template_section_folder = "";
  @observable report_types = []
  @observable valid_groups = []
  @observable group_based_reports = []
  @observable url = "/api/v1/guestreportactions";
  @observable end_date = "";
  @observable start_date = "";
  @observable report_Availability = {};

  @action setEndDate = (value) => {
    this.end_date = value;
  };
  @action setStartDate = (value) => {
    this.start_date = value;
  };
  @action setErrors = () => {
    this.errors = {};
  };
  @action setTemplateReport = (name) => {
    this.template_report = name;
  };

  @action setAction = action => {
    this.action = action;
  };
  @action getGroupName = async id => {
    try {
      const report = await get(
        `${this.url}/getGroupName/${id}`
      );
      return report.data.name;
    }
    catch (e) {
      console.log(e);
    }
  }
  @action get_report_info = async (group_id,report_name) => {
    try {
      const report_section = await get(
        `/api/v1/userentityactions/get_report_info/${group_id}/${report_name}`,
      );
      this.template_section = report_section.data.screens;
      this.template_section_folder = report_section.data.folder;
    }
    catch (e) {
      console.log(e);
    }
  }

  @action getGroupLabeling = async (group_id, type="group") => {
    try {
      const report = await get(
        `${this.url}/getGroupLabeling/${group_id}?type=${type}`
      );

      return report.data;
    }
    catch (e) {
      console.log(e);
    }
  }
  @action validateGroups = async (data) => {
    this.valid_groups = []
    try {
      const report = await post(
        `/api/v1/reportactions/validateGroups/${data.type}`, { groups: data.groups }
      );
      this.valid_groups = report.data;
    }
    catch (e) {
      console.log(e);
    }
  }
  @action validateGroupsV2 = async (data,isType=false) => {
    this.group_based_reports = []
    try {
      const group_report = await post(
        `/api/v1/reportactions/validateGroupsV2${isType ? "?type=broker":""}`, data
      );
      this.group_based_reports = group_report.data;
    }
    catch (e) {
      console.log(e);
    }
  }


  @action getReportByUUID = async uuid => {
    try {
      const report = await get(
        `${this.url}/getReportByUUID/${uuid}`
      );
      return report.data;
    }
    catch (e) {
      console.log(e);
    }
  }
  @action deleteReport = async id => {
    try {
      const report = await deleted(
        `/api/v1/reportactions//deleteReport/${id}`
      );
      return report.data;
    }
    catch (e) {
      console.log(e);
    }
  }
  @action getReportAvailability = async () => {
    try {
      const report = await get(
        `/api/v1/reportactions/getReportAvailability`
      );
      this.report_Availability= report.data.rows[0];
    }
    catch (e) {
      console.log(e);
    }
  }

  @action getAllReports = async data => {
    const entityData = await get(
      `/api/v1/reportactions/getallReports?limit=${this.limit}&&offset=${data.offset}&&type=${data?.type ?? ""}&&name=${data?.name ?? ""}&&search=${data?.search ?? ""}`
    );
    this.reports = entityData.data.rows;
    let count = parseInt(entityData.data.count);
    this.tiles =
      count % this.limit == 0
        ? parseInt(count / this.limit)
        : parseInt(count / this.limit) + 1;
  }
  @action getAllAdminReports = async data => {
    const entityData = await get(
      `/api/v1/adminreportActions/getallReports?limit=${this.limit}&&offset=${data.offset}&&type=${data?.type ?? ""}&&name=${data?.name ?? ""}&&search=${data?.search ?? ""}`
    );
    this.reports = entityData.data.rows;
    let count = parseInt(entityData.data.count);
    this.tiles =
      count % this.limit == 0
        ? parseInt(count / this.limit)
        : parseInt(count / this.limit) + 1;
  }

  @action generateReportPdf = async data => {
    this.reportError = "";
    try {
      await post(
        `/api/v1/reportactions/generateReport`, data
      );
      return true
    }
    catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action generateClaimsPdf = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/dataactions/claims/generateClaimsPdf",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action getReportTypes = async (flag, id) => {
    if(!id) id=-1;
    try {
      let response = await get(
        `/api/v1/reportactions/getReportsType/${id}`
      );
      if (!flag) {
        let temp_array = [];
        for (const iterator of response.data) {
          if (iterator.section != "Market Check Report" || iterator.section != "Market Check Report New") {
            temp_array.push(iterator)
          }
        }
        this.report_types = temp_array;
        return
      }
      this.report_types = response.data;
    } catch (err) {

      console.log(err);
      return false
    }
  }

  @action generatePhysicianCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/dataactions/physicians/generatePhysicianCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }
  @action generateRxValetPapCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/RxValetPap/generateRxValetPapCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }
  @action generateInternationalTeleHealthCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/InternationalTeleHealth/generateInternationalTeleHealthCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }
  @action generateRxValetInternationalCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/RxValetInternational/generateRxValetInternationalCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action generateParticipantCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/dataactions/participants/generateParticipantCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }
  @action generatePharmacyCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/dataactions/pharmacies/generatePharmacyCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action getCostPlusCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/CostPlus/getCostPlusCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }
  @action getInternationalRxCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/InternationalRx/getInternationalRxCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }
  @action getAlternativeFundingCSV = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/AlternativeFunding/getAlternativeFundingCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action getPrecisionPgxCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/pgx/getPrecisionPgxCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action getRxTourismCSV = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/rxtourism/getRxTourismCSV",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action getSpecialtyCarveoutCsv = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/recommendationactions/SpecialtyCarveOut/getSpecialtyCarveoutCsv",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action generateGuaranteeCSV = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/performaneactions/guarantee/generateGuaranteeCSV",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }

  @action generateDispensingCSV = async (data) => {
    this.reportError = "";
    try {
      await post(
        "/api/v1/performaneactions/dispensing/generateDispensingCSV",
        data
      );
      return true;
    } catch (e) {
      this.reportError = e.response.data;
      return false
    }
  }


}

export default ReportStore;
